export default {"src":"/_next/static/media/SE.52162289.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};